import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import { AppLayout, SiteLayout, ViewerLayout } from "@/layout";
import { siteRouter } from "@/modules/Site/router";
import { inventoryRouter } from "@/modules/Inventory/router";
import { preparationSlipRouter } from "@/modules/PreparationSlip/router";
import { statisticsRouter } from "@/modules/Statistics/router";
import { orderTemplateRouter } from "@/modules/OrderTemplate/router";
import { deliverySlipRouter } from "@/modules/DeliverySlip/router";
import { tagManagerRouter } from "@/modules/TagManager/router";
import { customUnitRouter } from "@/modules/CustomUnit/router";
import { customerAccountRouter } from "@/modules/CustomerAccount/router";
import { recipeRouter } from "@/modules/Recipes/router";
import { supplierRouter } from "@/modules/Suppliers/router";
import { tillRouter } from "@/modules/Till/router";
import { salesRouter } from "@/modules/Ventes/router";
import { analyticRouter } from "@/modules/Analytics/router";
import { helperRouter } from "@/modules/Helper/router";
import { userSettingsRouter } from "@/modules/UserSettings/router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: SiteLayout,
    children: [...siteRouter]
  },
  {
    path: "/app",
    name: "AppHome",
    component: AppLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      ...orderTemplateRouter,
      ...deliverySlipRouter.main,
      ...tagManagerRouter.main,
      ...statisticsRouter,
      ...customUnitRouter,
      ...preparationSlipRouter.main,
      ...customerAccountRouter,
      ...inventoryRouter.main,
      ...recipeRouter.main,
      ...supplierRouter,
      ...tillRouter,
      ...salesRouter,
      ...analyticRouter,
      ...userSettingsRouter
    ]
  },
  {
    path: "/viewer",
    name: "Viewer",
    component: ViewerLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      ...deliverySlipRouter.viewer,
      ...tagManagerRouter.viewer,
      ...preparationSlipRouter.viewer,
      ...inventoryRouter.viewer,
      ...recipeRouter.viewer,
      ...helperRouter
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  if (requiresAuth && store.getters.getAuthToken === null) {
    next("/");
  } else if (requiresAuth && store.getters.getAuthToken !== null) {
    next();
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  const requiresAdmin = to.matched.some(x => x.meta.requiresAdmin);
  if (requiresAdmin && store.getters.getIsAdmin === false) {
    next("/app");
  } else if (requiresAdmin && store.getters.getIsAdmin === true) {
    next();
  } else {
    next();
  }
});

export { router };
